import styled from '@emotion/styled'
import Button from '@material-ui/core/Button'

/** Right side of the card top row holding the action buttons. */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`

/** MUI button restyled for the card actions (no upper-casing, never wraps). */
export const ActionButton = styled(Button)`
  text-transform: none;
  white-space: nowrap;
`
